// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';
import {
    Shipment,
}                               from 'shippo';

// ===== Interfaces =====

import {
    IShippoAddressObject,
}                               from '../interfaces';

const shippoCreateShipment = async ({
    test,
    paymentIntentId,
    addressTo,
    physicalItemsInCart,
    internationalShipment,
}: {
    test: boolean,
    paymentIntentId: string,
    addressTo: IShippoAddressObject,
    physicalItemsInCart: string[],
    internationalShipment: boolean,
}): Promise<Shipment> => {
    const functions = getFunctions();
    const createShipment = httpsCallable<
        Record<
            string,
            boolean | IShippoAddressObject | string | string[]
        >,
        Shipment
    >(
        functions,
        'shippoCreateShipment',
    );
    return createShipment({
        test,
        paymentIntentId,
        addressTo,
        physicalItemsInCart,
        internationalShipment,
    }).then((result) => {
        const shipment = result.data as Shipment;
        return shipment;
    }).catch((err) => {
        throw err;
    });
};

export default shippoCreateShipment;
